import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FacilitiesIdDropdownService {
    private form: FormGroup | null = null;

    setForm(form: FormGroup): void {
        this.form = form;
    }

    getForm(): FormGroup | null {
        return this.form;
    }

    markAsTouched(): void {
        if (this.form) {
            this.form.markAllAsTouched();
        }
    }

    isValid(): boolean {
        return this.form ? this.form?.valid : true;
    }
}
